import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectBranchState } from "../store/branch/selectors";
import { getBranchesByTenant } from "../store/branch/thunks";

export const useTenantBranches = (fetch = false) => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { branchesByTenants, loading, ...branchState } =
    useSelector(selectBranchState);

  useEffect(() => {
    if (fetch && selectedTenantId && !branchesByTenants[selectedTenantId]) {
      dispatch(getBranchesByTenant({ tenant_id: selectedTenantId }));
    }
  }, [selectedTenantId, branchesByTenants, fetch]);

  const branches = useMemo(() => {
    return branchesByTenants[selectedTenantId] || [];
  }, [branchesByTenants, selectedTenantId]);

  const branchOptions = useMemo(() => {
    return branches.map((branch) => ({
      value: branch.id,
      label: branch.name,
    }));
  }, [branches]);

  return { branches, loading, selectedTenantId, branchState, branchOptions };
};
